import { render, staticRenderFns } from "./Notifications.vue?vue&type=template&id=1b187322"
import script from "./Notifications.vue?vue&type=script&setup=true&lang=ts"
export * from "./Notifications.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Notifications.vue?vue&type=style&index=0&id=1b187322&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports